<template>
  <div>
    <v-expansion-panels v-model="expandedPanel">
      <v-expansion-panel
        v-for="(category, catIndex) in categoryList"
        :key="category"
        :value="category"
      >
        <v-expansion-panel-title :class="rowClass(catIndex)">
          <template #actions="{ expanded }">
            <v-btn
              color="primary"
              size="small"
              :icon="expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
            />
          </template>
          <span class="text-headline-small text-primary-darken-1">{{ category }}</span>
        </v-expansion-panel-title>
        <v-expansion-panel-text
          class="no-padding-panel"
        >
          <v-expansion-panels
            v-model="expandedSubPanel"
          >
            <v-expansion-panel
              v-for="(faq, index) in getCategoryItems(category)"
              :key="faq.id"
              :value="faq.id"
            >
              <v-expansion-panel-title
                :class="rowClass(index)"
                class="d-flex align-start"
              >
                <template #actions="{ expanded }">
                  <v-btn
                    color="primary"
                    size="small"
                    variant="plain"
                    :icon="expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
                  />
                </template>
                <span
                  class="text-title-large text-font"
                  style="font-size: 1.20rem;"
                >{{ faq.question }}</span>
              </v-expansion-panel-title>
              <v-expansion-panel-text
                class="px-5 pb-5"
                :class="rowClass(index)"
              >
                <rich-text-content
                  :data="faq.answer"
                />
                <copy-url
                  :model="faq"
                  class="mt-3 mr-2"
                />
                <share-page
                  :model="faq"
                  :name="t('faq.share')"
                  class="mt-3"
                />
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import CopyUrl from '@/components/carts/CopyUrl.vue';
import SharePage from '@/components/carts/SharePage.vue';
import RichTextContent from '@/components/rich-text/RichTextContent.vue';
import { useDataTableUtilities } from '@/composables';

const props = defineProps<{
  items: Array<App.Models.Faq>;
}>();
const { watchInt, getIntFromQuery, getStringFromQuery, watchString } = useDataTableUtilities();
const { t } = useI18n();
const tab = ref('');
const categoryList = ref<string[]>([]);
const route = useRoute();
const expandedPanel = ref<string | undefined>(getStringFromQuery(route?.query?.panel));
const expandedSubPanel = ref<number | undefined>(getIntFromQuery(route?.query?.faq));
watchString(expandedPanel, 'panel');
watchInt(expandedSubPanel, 'faq');
onMounted(() => {
  categoryList.value = [
    ...new Set(props.items.map((p) => (p.categories ?? []).map((q) => q.name)).flat()),
  ];
  tab.value = categoryList.value[0];
});

function rowClass(number: number): string {
  return (number % 2 === 0) ? 'bg-light-grey' : '';
}
function getCategoryItems(category: string): App.Models.Faq[] {
  return props.items
    .filter((p) => (p.categories ?? []).map((q) => q.name).includes(category))
    .sort(
      (firstEl, secondEl) =>
        (firstEl.order?.[category] ?? 0) - (secondEl.order?.[category] ?? 0),
    );
}
</script>
